import { render, staticRenderFns } from "./ForumList.vue?vue&type=template&id=6d203384"
import script from "./ForumList.vue?vue&type=script&lang=js"
export * from "./ForumList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports